import React from 'react';
import styles from './About.module.css';
import useReveal from './useReveal';

const values = [
  { icon: '⚡', name: 'Innovation', desc: 'Cutting-edge solutions with the latest technologies.' },
  { icon: '🔒', name: 'Reliability', desc: 'Consistent results businesses depend on.' },
  { icon: '💎', name: 'Excellence', desc: 'We strive for excellence in every project.' },
  { icon: '🤝', name: 'Client Success', desc: 'Your growth is our ultimate measure.' },
];

export default function About() {
  const leftRef = useReveal();
  const rightRef = useReveal();

  return (
    <section className={styles.about} id="about">
      <div className={styles.inner}>
        <div className={`reveal ${styles.left}`} ref={leftRef}>
          <span className="section-label">// about us</span>
          <h2 className="section-title">
            Not Just <em>Builders</em> —<br />Growth Architects
          </h2>
          <p className="section-sub">
            Inspired by HTTP 404, our brand symbolizes exactly what we do: when systems break or
            businesses struggle, we provide the complete technology stack and marketing strategy
            to rebuild and grow stronger.
          </p>
          <div className={styles.valuesGrid}>
            {values.map((v) => (
              <div key={v.name} className={styles.valueItem}>
                <span className={styles.vIcon}>{v.icon}</span>
                <strong className={styles.vName}>{v.name}</strong>
                <p className={styles.vDesc}>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className={`reveal ${styles.right}`} ref={rightRef}>
          <div className={`${styles.card} ${styles.cardTop}`}>
            <div className={styles.cardIcon}>🎯</div>
            <h4>Our Mission</h4>
            <p>Empower businesses with modern technology and digital marketing strategies that drive growth, innovation, and long-term success.</p>
          </div>
          <div className={`${styles.card} ${styles.cardBottom}`}>
            <div className={styles.cardIcon}>🌐</div>
            <h4>Our Vision</h4>
            <p>To become a trusted global technology and digital marketing partner for businesses seeking innovative digital transformation solutions.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
